import { render, staticRenderFns } from "./UpcomingTimeline.vue?vue&type=template&id=2edaf480&scoped=true&"
import script from "./UpcomingTimeline.vue?vue&type=script&lang=js&"
export * from "./UpcomingTimeline.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingTimeline.vue?vue&type=style&index=0&id=2edaf480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edaf480",
  null
  
)

export default component.exports